import { FuelTypography } from '@frete.com/fuel-react';
import * as Styled from './styled';
import { Props } from './types';

function Loading({ visible }: Props) {
  return (
    visible && (
      <Styled.LoadingWrapper>
        <Styled.Ellipse />
        <Styled.Ilustra />
        <FuelTypography size="body-md" weight="medium">
          Aguarde enquanto analisamos seu CNPJ
        </FuelTypography>
        <FuelTypography size="body-md" color="neutral-default">
          Isso pode demorar alguns segundos.
        </FuelTypography>
      </Styled.LoadingWrapper>
    )
  );
}

export default Loading;
